<template>
  <div>
    
    <div class="articles sec-mt">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 order-1 order-md-2 mb-5">
            <img v-if="row.image4" :src="row.image4" :alt="row.title4">
          </div>
          <div class="col-md-6 order-2 order-md-1 mb-5">
            <p class="title" v-html="row.title4" :style="'color:'+row.color4+' !important;font-family:dubai-b !important'"></p>
            <p class="sub-title" v-html="row.desc4" :style="'color:'+row.colorDesc4+' !important'"></p>
            <router-link v-if="row.button4" :to="row.redirect4" class="btn-primary btn--black" style='float:left'>
                <div class="d-flex align-items-center">
                  {{ row.button4 }} 
                  <span class="icon-arrow-right ml-2"></span>
                </div>
            </router-link>
          </div>

          <div class="col-md-6 order-3 order-md-3 mb-5 sec-mt">
            <div class="article-d">
              <img v-if="row.image5" :src="row.image5" :alt="row.title5">
              <div class="content">
                <p class="mb-5" v-html="row.title5" :style="'color:'+row.color5+' !important;white-space:break-spaces;font-family:dubai-m !important'"></p>
                <router-link v-if="row.button5" :to="row.redirect5" class="btn-primary d-inline-block btn-white">
                    <div class="d-flex align-items-center">
                      {{ row.button5 }} 
                      <span class="icon-arrow-right ml-2"></span>
                    </div>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-md-6 order-4 order-md-4 mb-5 sec-mt">
            <div class="article-d">
              <img v-if="row.image6" :src="row.image6" :alt="row.title6">
              <div class="content-bg">
                <p class="" v-html="row.title6" :style="'color:'+row.color6+' !important;font-family:dubai-m !important'"></p>
                <p class="min-title" v-html="row.desc6" :style="'color:'+row.colorDesc6+' !important;font-weight:600'"></p>
                <router-link v-if="row.button6" :to="row.redirect6" class="btn-primary btn-white" style='float:left'>
                    <div class="d-flex align-items-center">
                      {{ row.button6 }} 
                      <span class="icon-arrow-right ml-2"></span>
                    </div>
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.icon-arrow-right {
  font-weight: bold;
  font-size: 17px;
}
.btn--black {
  border: 1px solid #000; 
}
.btn-white {
  border: 1px solid #fff
}
</style>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
